import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const PatientDoctorsInfo = ({ doctor, clinic }) => (
  <Table
    className="patient-doctor-info"
    borderless
    border="0"
    cellSpacing="0"
    cellPadding="0"
  >
    <thead>
      <tr>
        <th>Physician</th>
        <th>Details</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Doctor</td>
        <td>
          <span>{`${doctor.firstName} ${doctor.lastName}`}</span>
          <span>{doctor.professionType}</span>
          {doctor.status === 'inactive' && (
            <span className="error-message">
              *the doctor is currently inactive
            </span>
          )}
        </td>
      </tr>
      <tr>
        <td>Clinic</td>
        <td>
          {clinic.legalname && <span>Legal Name: {clinic.legalname}</span>}
          {clinic.email && <span>Email: {clinic.email}</span>}
          {clinic.phone && <span>Phone Number: {clinic.phone}</span>}
          {clinic.fax && <span>Fax: {clinic.fax}</span>}
          {clinic.officeHours && (
            <span>Office Hours: {clinic.officeHours}</span>
          )}
          {(clinic.addressLine1 || clinic.addressLine2) && (
            <span>
              Addresses: {clinic.addressLine1} {clinic.addressLine2}
            </span>
          )}
          {clinic.city && <span>City: {clinic.city}</span>}
          {clinic.state && <span>State: {clinic.state}</span>}
          {clinic.zip && <span>Zip: {clinic.zip}</span>}
        </td>
      </tr>
    </tbody>
  </Table>
);

PatientDoctorsInfo.propTypes = {
  doctor: PropTypes.shape(),
  clinic: PropTypes.shape(),
};

export default PatientDoctorsInfo;
